import { render, staticRenderFns } from "./signup_page.vue?vue&type=template&id=f31b6812"
import script from "./signup_page.vue?vue&type=script&lang=js"
export * from "./signup_page.vue?vue&type=script&lang=js"
import style0 from "./signup_page.vue?vue&type=style&index=0&id=f31b6812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports